import React from 'react';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';
import '../../../public/css/RightNavigation.css';

class RightNavigationContainer extends React.Component {
  render() {
    return (
      <div
        className={`sidnav-container ${
          this.props.show ? 'show-menu' : 'hide-menu'
        }`}
      >
        <div className="sidenav">
          <div className="user-greeting">
            <div className="greeting-label">
              <FormattedMessage
                id="hello"
                defaultMessage={defaultMsg.hello}
              />,
            </div>
            <div className="greeting-name">
              {this.props.auth.authenticated
                ? this.props.auth.loginUserDetails.firstName
                : this.props.auth.name}
            </div>
          </div>
          <span className="close-side-nav ">
            <i onClick={() => this.props.toggle()} className="fa fa-times" />
          </span>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default RightNavigationContainer;



// WEBPACK FOOTER //
// ./src/views/menu/components/RightNavigationContainer.jsx